/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sleek_Brief_Midge_RoarInputs */

const fr_sleek_brief_midge_roar = /** @type {(inputs: Sleek_Brief_Midge_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

/**

* @param {Sleek_Brief_Midge_RoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sleek_brief_midge_roar = /** @type {((inputs?: Sleek_Brief_Midge_RoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sleek_Brief_Midge_RoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sleek_brief_midge_roar(inputs)
});